import { validation } from './helpers';
import { store as reduxStore } from '~/store';

export const SIZES_AND_AGE = 'SIZES_AND_AGE';
export const HAIR_SKIN_EYES = 'HAIR_SKIN_EYES';
export const ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION';
export const YOUR_APPOINTMENT = 'YOUR_APPOINTMENT';

export const inlineErrorMessagingQuestions = [
  // Personal Styling
  {
    name: 'personalStylingAgeQuestion',
    message: 'Please choose your age range',
  },
  {
    name: 'personalStylingFemaleWhatSpecificallyDoYouNeedHelpWith',
    message: 'Please fill out this information',
  },
  {
    name: 'personalStylingMaleWhatSpecificallyDoYouNeedHelpWith',
    message: 'Please fill out this information',
  },
  {
    name: 'personalStylingFemaleRecommendedByAFriendEmailQuestion',
    validate: [validation.validateEmail],
  },
  // Home design at Home Your project question
  {
    name: 'designConsultationAboutYourProjectQuestion',
    message: 'Please enter details about your project',
  },
  // Home design in Store Your room question
  {
    name: 'styleAdviceAboutYourRoomQuestion',
    message: 'Please enter details about your room',
  },
  // Gift list mobile phone question
  {
    name: 'giftListPhoneQuestion',
    validate: [validation.validatePhoneNumberUKMobile],
  },
  // Gift list Someone else name question
  {
    name: 'giftListNameQuestion',
    validate: [validation.validateSomeoneElseName],
  },
  // Gift list Event Date Validation
  {
    name: 'giftListDateQuestion',
    validate: [validation.required],
    validateWithState: () => [validation.validateDateExcess(reduxStore.getState)],
  },
  // Beauty Society
  {
    name: 'beautySocietyPhoneQuestion',
    validate: [validation.validatePhoneNumberUKMobile],
  },
  {
    name: 'beautySocietyNameQuestion',
    validate: [validation.validateSomeoneElseName],
  },
  // Beauty
  {
    name: 'beautyPhoneQuestion',
    validate: [validation.validatePhoneNumberUKMobile],
  },
  // Beauty Someone else name question
  {
    name: 'beautyNameQuestion',
    validate: [validation.validateSomeoneElseName],
  },
];
